import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/system/sms-configs')({
  beforeLoad: () => {
    throw redirect({
      to: '/system/configs',
      search: { section: 'sms' },
      replace: true,
    });
  },
});
